import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { MapPin, Briefcase, GraduationCap, User, Calendar } from 'lucide-react';

const BasicInfoStep = ({ formData, updateFormData }) => {
  return (
    <div className="space-y-6">
      <p className="text-neutral-600 mb-6">
        Let's start with some basic information about you
      </p>
      
      {/* Age and Gender */}
      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="age">Age *</Label>
          <div className="relative">
            <Calendar className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-neutral-400" />
            <Input
              id="age"
              type="number"
              placeholder="27"
              min="18"
              max="99"
              value={formData.age}
              onChange={(e) => updateFormData({ age: e.target.value })}
              className="pl-10"
            />
          </div>
        </div>
        
        <div className="space-y-2">
          <Label htmlFor="gender">Gender *</Label>
          <Select value={formData.gender} onValueChange={(value) => updateFormData({ gender: value })}>
            <SelectTrigger>
              <SelectValue placeholder="Select" />
            </SelectTrigger>
            <SelectContent>
              {/* C.1c: canonical values are ONLY male / female. */}
              <SelectItem value="male">Male</SelectItem>
              <SelectItem value="female">Female</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>
      
      {/* Location */}
      <div className="space-y-2">
        <Label htmlFor="city">City *</Label>
        <div className="relative">
          <MapPin className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-neutral-400" />
          <Input
            id="city"
            type="text"
            placeholder="San Francisco"
            value={formData.city}
            onChange={(e) => updateFormData({ city: e.target.value })}
            className="pl-10"
          />
        </div>
      </div>
      
      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="state">State/Province</Label>
          <Input
            id="state"
            type="text"
            placeholder="California"
            value={formData.state}
            onChange={(e) => updateFormData({ state: e.target.value })}
          />
        </div>
        
        <div className="space-y-2">
          <Label htmlFor="country">Country *</Label>
          <Input
            id="country"
            type="text"
            placeholder="United States"
            value={formData.country}
            onChange={(e) => updateFormData({ country: e.target.value })}
          />
        </div>
      </div>
      
      {/* Occupation & Education */}
      <div className="space-y-2">
        <Label htmlFor="occupation">Occupation</Label>
        <div className="relative">
          <Briefcase className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-neutral-400" />
          <Input
            id="occupation"
            type="text"
            placeholder="e.g., Software Engineer, Doctor, Teacher"
            value={formData.occupation}
            onChange={(e) => updateFormData({ occupation: e.target.value })}
            className="pl-10"
          />
        </div>
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="education">Education</Label>
        <div className="relative">
          <GraduationCap className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-neutral-400" />
          <Input
            id="education"
            type="text"
            placeholder="e.g., Bachelor's Degree, Master's Degree"
            value={formData.education}
            onChange={(e) => updateFormData({ education: e.target.value })}
            className="pl-10"
          />
        </div>
      </div>
    </div>
  );
};

export default BasicInfoStep;
